export class Terminal {
	id:string;
	type:string;

	public constructor(data:any){
		this.id = data.id;
		this.type = data.type;
	}

	public toString(){
		return `${this.id} (${this.type})`;
	}
}